import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "emergency-roof-leak-repair-in-phoenix-what-to-do-first";
export const Route = createFileRoute("/emergency-roof-leak-repair-in-phoenix-what-to-do-first")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
